import moment from 'moment';
import { Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from '@react-google-maps/api';

const ShowMap = ({ open, onCancel, dataArray, geoFenceLocationOnMap, whichMapToShow }) => {

    const [map, setMap] = useState(null);

    const containerStyle = {
        width: "100%",
        height: "80vh",
        borderRadius: 10,
        padding: 0
    };

    // Was hardcoded to an unrelated Sao Paulo coordinate regardless of which
    // location was actually being shown — the marker still plotted at the
    // real lat/lng, but centered/zoomed on the wrong side of the globe, it
    // was effectively never visible ("the map not working"). Center on
    // whatever location this modal was actually opened for instead; the
    // old constant is now only a last-resort fallback if a location is ever
    // shown with no coordinates at all.
    const firstMarkerWithCoords = dataArray?.find(marker => marker?.latitude && marker?.longitude);
    const fallbackCenter = { lat: -3.745, lng: -38.523 };
    const center = whichMapToShow === 'locationsMap'
        ? (firstMarkerWithCoords
            ? { lat: firstMarkerWithCoords.latitude, lng: firstMarkerWithCoords.longitude }
            : fallbackCenter)
        : (geoFenceLocationOnMap?.latitude && geoFenceLocationOnMap?.longitude
            ? { lat: geoFenceLocationOnMap.latitude, lng: geoFenceLocationOnMap.longitude }
            : fallbackCenter);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyANNuGsbyjTzqrtYc65aRapQ1fkfaVh0aI",
        libraries: ["places"]
    })

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    const onLoad = React.useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);
        setMap(map)
    }, [center])

    return (
        <Modal
            centered
            open={open}
            onCancel={onCancel}
            footer={null}
            width={745}
            bodyStyle={{ padding: 0 }}
            className='modal-round-corner'
        >
            <div>
                {isLoaded ?
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        onLoad={onLoad}
                        center={center}
                        onUnmount={onUnmount}
                        defaultZoom={15}
                        zoom={13}
                        options={{
                            fullscreenControl: false,
                            streetView: false,
                            streetViewControl: false,
                            streetViewControlOptions: false
                        }}
                    >
                        {whichMapToShow == 'locationsMap' ?

                            dataArray?.map(marker => {
                                return (
                                    <Marker
                                        key={marker?.id}
                                        position={{ lat: marker?.latitude, lng: marker?.longitude }}
                                    >
                                        <InfoWindow>
                                            <div>
                                                {marker?.geoFenceTitle ? marker?.geoFenceTitle : marker?.title}
                                            </div>
                                        </InfoWindow>
                                    </Marker>
                                )
                            })
                            :
                            <Marker
                                key={geoFenceLocationOnMap?.id}
                                position={{ lat: geoFenceLocationOnMap?.latitude, lng: geoFenceLocationOnMap?.longitude }}
                            >
                                <InfoWindow>
                                    <div>
                                        {geoFenceLocationOnMap?.geoFenceTitle ? geoFenceLocationOnMap?.geoFenceTitle : geoFenceLocationOnMap?.title}
                                    </div>
                                </InfoWindow>
                            </Marker>
                        }
                    </GoogleMap>
                    :
                    null
                }
            </div>
        </Modal>
    )
}

export default ShowMap